<modal-form-container
  title="Add to organizations"
  className="md:w-[720px] lg:w-[760px]"
  [showModal]="showModal"
  (closeModalEvent)="closeModal()"
>
  @if (showModal) {
    <div class="gm">
      <p class="gm__lead">
        Choose the organizations to add <strong>{{ contactLabel }}</strong> to.
      </p>

      <bk-group-picker kind="organization" [selected]="selectedOrganizations" (selectedChange)="updateSelection($event)" />

      @if (errorMsg) {
        <p class="gm__error" role="alert"><span class="bk-sym" aria-hidden="true">error</span>{{ errorMsg }}</p>
      }

      <div class="gm__foot">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="closeModal()">Cancel</button>
        <button
          type="button"
          class="bk-btn bk-btn--primary"
          [disabled]="!selectedOrganizations.length || saving"
          (click)="handleSubmit()"
        >
          {{ submitLabel }}
        </button>
      </div>
    </div>
  }
</modal-form-container>
